/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatMessage } from './ChatMessage';

export type ChatThread = {
    id: string;
    title?: string | null;
    isPinned: boolean;
    /**
     * Status of the in-flight generation turn, or null if idle.
     */
    activeTurnStatus?: ChatThread.activeTurnStatus | null;
    /**
     * When the active turn started, or null if idle.
     */
    activeTurnStartedAt?: string | null;
    /**
     * When the active turn completed or failed, or null if idle or in progress.
     */
    activeTurnCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    messages?: Array<ChatMessage>;
};

export namespace ChatThread {

    /**
     * Status of the in-flight generation turn, or null if idle.
     */
    export enum activeTurnStatus {
        ACTIVE = 'active',
        FAILED = 'failed',
    }


}

